import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MovieCategory from "../pages/movie-category/page";
import MovieDetail from "../pages/movie-detail/page";
import Search from "../pages/search/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/movie-category",
    element: <MovieCategory />,
  },
  {
    path: "/movie-detail/:id",
    element: <MovieDetail />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;